/* Dear John Greenhouses: product page (Lovable ProductDetail port). Text helpers live in snippets/custom-product-text.liquid.
   - DJProduct: swipeable gallery, thumbnails, variant picker, quantity, collapsibles, gift tooltip, mobile sticky bar.
     Works on the whole section root, so the blocks (/blocks/_custom-product-*) can be in any order.
   Add to cart stays with Shrine's <product-form> (this file only changes the hidden variant id). */
(function () {
  'use strict';

  /* ---------- Interactive parts ---------- */
  function money(cents, decimals) {
    var d = decimals === undefined ? 2 : decimals;
    return (cents / 100).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  function initProduct(root) {
    if (root.dataset.djReady) return;
    root.dataset.djReady = '1';
    var dataEl = root.querySelector('[data-dj-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var variants = product.variants;
    var images = product.images;

    /* Gallery: swipeable track (CSS scroll-snap) + thumbnails + arrows */
    var track = root.querySelector('[data-dj-track]');
    var slides = track ? track.querySelectorAll('[data-dj-slide]') : [];
    var counter = root.querySelector('[data-dj-slide-current]');
    var slidePrev = root.querySelector('[data-dj-slide-prev]');
    var slideNext = root.querySelector('[data-dj-slide-next]');
    var thumbsGrid = root.querySelector('[data-dj-thumbs]');
    var prevBtn = root.querySelector('[data-dj-thumb-prev]');
    var nextBtn = root.querySelector('[data-dj-thumb-next]');
    var visible = 5, thumbStart = 0, selected = Number(root.dataset.initialImage || 0);
    // desktop: vertical rail shows every thumbnail and scrolls itself (CSS in custom-main-product.css)
    var railMq = window.matchMedia('(min-width: 990px)');
    function isRail() { return railMq.matches && root.querySelector('.dj-pdp__gallery--rail'); }
    function railReveal(b) {
      var pad = parseFloat(getComputedStyle(thumbsGrid).paddingTop) || 0;
      var top = Math.max(0, b.offsetTop - pad), bottom = b.offsetTop + b.offsetHeight + pad, view = thumbsGrid.clientHeight, cur = thumbsGrid.scrollTop;
      if (top < cur) thumbsGrid.scrollTo({ top: top, behavior: 'smooth' });
      else if (bottom > cur + view) thumbsGrid.scrollTo({ top: bottom - view, behavior: 'smooth' });
    }

    function renderThumbs() {
      if (thumbsGrid) {
        var buttons = thumbsGrid.querySelectorAll('[data-dj-thumb]');
        var rail = isRail();
        var scrolling = !rail && images.length > visible;
        buttons.forEach(function (b, i) {
          var show = !scrolling || (i >= thumbStart && i < thumbStart + visible);
          b.hidden = !show;
          b.classList.toggle('is-active', i === selected);
          if (i === selected) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          if (rail && i === selected) railReveal(b);
        });
        if (prevBtn) prevBtn.disabled = thumbStart <= 0;
        if (nextBtn) nextBtn.disabled = thumbStart + visible >= images.length;
      }
      if (counter) counter.textContent = selected + 1;
      if (slidePrev) slidePrev.disabled = selected <= 0;
      if (slideNext) slideNext.disabled = selected >= slides.length - 1;
    }
    function setSelected(i) {
      selected = i;
      // keep the active thumbnail inside the visible window
      if (selected < thumbStart) thumbStart = selected;
      if (selected >= thumbStart + visible) thumbStart = selected - visible + 1;
      renderThumbs();
    }
    function selectImage(i, instant) {
      if (!slides[i]) return;
      setSelected(i);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    if (track && slides.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== selected && slides[i]) setSelected(i);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); selectImage(Math.max(0, selected - 1)); }
        if (e.key === 'ArrowRight') { e.preventDefault(); selectImage(Math.min(slides.length - 1, selected + 1)); }
      });
      // mouse drag-to-swipe on desktop (touch and trackpads scroll natively)
      var dragX = null;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button === 0) dragX = e.clientX; });
      window.addEventListener('pointerup', function (e) {
        if (dragX === null) return;
        var dx = e.clientX - dragX;
        dragX = null;
        if (Math.abs(dx) > 40) selectImage(Math.max(0, Math.min(slides.length - 1, selected + (dx < 0 ? 1 : -1))));
      });
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      if (slidePrev) slidePrev.addEventListener('click', function () { selectImage(Math.max(0, selected - 1)); });
      if (slideNext) slideNext.addEventListener('click', function () { selectImage(Math.min(slides.length - 1, selected + 1)); });
      if (selected > 0) selectImage(selected, true);
    }
    if (thumbsGrid) {
      thumbsGrid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dj-thumb]');
        if (!b) return;
        e.preventDefault();
        selectImage(Number(b.dataset.djThumb));
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { thumbStart = Math.max(0, thumbStart - 1); renderThumbs(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { thumbStart = Math.min(images.length - visible, thumbStart + 1); renderThumbs(); });
    renderThumbs();
    if (railMq.addEventListener) railMq.addEventListener('change', renderThumbs);

    /* Variant picker */
    var current = variants.find(function (v) { return String(v.id) === root.dataset.initialVariant; }) || variants[0];
    function selectedOptions() { return current ? current.options.slice() : []; }
    // initial: true on page load: sync the UI without touching the URL (only a customer's change writes ?variant=)
    function update(initial) {
      if (!current) return;
      root.querySelectorAll('.product-variant-id').forEach(function (inp) { inp.value = current.id; });
      root.querySelectorAll('[data-dj-option-btn]').forEach(function (b) {
        var idx = Number(b.dataset.index);
        var on = current.options[idx] === b.dataset.value;
        b.classList.toggle('is-selected', on);
        if (b.hasAttribute('data-dj-pill')) {
          // Pills: radio semantics, roving tabindex, availability for this value with the other options as selected
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var opts = current.options.slice(); opts[idx] = b.dataset.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
          b.classList.toggle('is-unavailable', !match || !match.available);
          if (on) root.querySelectorAll('[data-dj-pill-current][data-index="' + idx + '"]').forEach(function (e) { e.textContent = b.dataset.djPillLength; });
        } else {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
      root.querySelectorAll('[data-dj-option-select]').forEach(function (s) { s.value = current.options[Number(s.dataset.index)]; });
      var onSale = current.compare_at_price && current.compare_at_price > current.price;
      root.querySelectorAll('[data-dj-price]').forEach(function (e) {
        e.textContent = '$' + money(current.price);
        e.classList.toggle('dj-pdp__price--sale', !!onSale);
      });
      root.querySelectorAll('[data-dj-compare]').forEach(function (e) { e.textContent = onSale ? '$' + money(current.compare_at_price) : ''; });
      root.querySelectorAll('[data-dj-off]').forEach(function (e) {
        e.textContent = onSale ? Math.round((current.compare_at_price - current.price) / current.compare_at_price * 100) + '% OFF' : '';
      });
      root.querySelectorAll('[data-dj-sale-only]').forEach(function (e) { e.hidden = !onSale; });
      root.querySelectorAll('[data-dj-regular-only]').forEach(function (e) { e.hidden = !!onSale; });
      var monthly = Math.ceil(current.price / 100 / 12);
      root.querySelectorAll('[data-dj-monthly0]').forEach(function (e) { e.textContent = '$' + monthly.toLocaleString('en-US'); });
      root.querySelectorAll('[data-dj-monthly2]').forEach(function (e) { e.textContent = '$' + monthly.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '/mo'; });
      root.querySelectorAll('[data-dj-atc-label]').forEach(function (e) { e.textContent = (e.dataset.prefix || 'Add to Cart - ') + '$' + money(current.price); });
      root.querySelectorAll('[data-dj-atc]').forEach(function (b) { b.disabled = !current.available; });
      if (current.featured_image_index !== null && current.featured_image_index !== undefined) selectImage(current.featured_image_index);
      if (!initial && window.history && window.history.replaceState && root.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    function choose(index, value) {
      var opts = selectedOptions();
      opts[index] = value;
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (match) { current = match; update(); }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dj-option-btn]');
      if (b) { e.preventDefault(); choose(Number(b.dataset.index), b.dataset.value); }
    });
    // Pills radio group: arrow keys / Home / End move focus and select (WAI-ARIA radio group)
    root.addEventListener('keydown', function (e) {
      var pill = e.target.closest('[data-dj-pill]');
      if (!pill) return;
      var pills = Array.prototype.slice.call(pill.closest('[data-dj-pills]').querySelectorAll('[data-dj-pill]'));
      var i = pills.indexOf(pill), next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = pills[(i + 1) % pills.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = pills[(i - 1 + pills.length) % pills.length];
      else if (e.key === 'Home') next = pills[0];
      else if (e.key === 'End') next = pills[pills.length - 1];
      if (!next) return;
      e.preventDefault();
      next.focus();
      choose(Number(next.dataset.index), next.dataset.value);
    });
    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-dj-option-select]');
      if (s) choose(Number(s.dataset.index), s.value);
      // Shrine's variant picker (Shrine: Variant picker block) sets the form's variant id and fires change: follow it so the
      // DJ blocks that show the price (sticky bar, Shop Pay line/box) stay in sync
      if (e.target.matches('input[name="id"]') && current && String(current.id) !== e.target.value) {
        var v = variants.find(function (x) { return String(x.id) === e.target.value; });
        if (v) { current = v; update(); }
      }
    });
    update(true);

    /* Collapsibles (shadcn Collapsible) */
    root.querySelectorAll('[data-dj-collapsible]').forEach(function (c) {
      var trigger = c.querySelector('[data-dj-collapsible-trigger]');
      var content = c.querySelector('[data-dj-collapsible-content]');
      trigger.addEventListener('click', function () {
        var open = c.getAttribute('data-state') !== 'open';
        c.setAttribute('data-state', open ? 'open' : 'closed');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.hidden = !open;
      });
    });

    /* Gift badge tooltip: opens on click, closes after 2.5 s */
    var gift = root.querySelector('[data-dj-gift]');
    if (gift) {
      var tip = gift.querySelector('[data-dj-gift-tip]'), timer;
      gift.addEventListener('click', function (e) {
        e.stopPropagation();
        tip.hidden = false;
        clearTimeout(timer);
        timer = setTimeout(function () { tip.hidden = true; }, 2500);
      });
      gift.addEventListener('mouseenter', function () { tip.hidden = false; });
      gift.addEventListener('mouseleave', function () { clearTimeout(timer); tip.hidden = true; });
    }

    /* Quantity block: +/- buttons (the input belongs to the add-to-cart form via its form attribute) */
    root.querySelectorAll('[data-dj-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      if (!document.getElementById(input.getAttribute('form'))) { box.closest('.dj-pdp__qty').hidden = true; return; }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dj-qty-step]');
        if (!b) return;
        e.preventDefault();
        var v = (parseInt(input.value, 10) || 1) + Number(b.dataset.djQtyStep);
        input.value = Math.max(1, v);
      });
    });

    /* Mobile sticky bar: visible after 300px of scroll; hidden when the page has no add-to-cart form to submit */
    var bar = root.querySelector('[data-dj-sticky]');
    var stickyBtn = bar && bar.querySelector('[data-dj-sticky-atc]');
    if (stickyBtn && !document.getElementById(stickyBtn.getAttribute('form'))) bar.hidden = true;
    if (bar && !bar.hidden) {
      var onScroll = function () { bar.classList.toggle('is-visible', window.scrollY > 300); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  window.DJProduct = { init: initProduct };
  function boot() { document.querySelectorAll('[data-dj-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
